
<!-- <app-page-ha-summary></app-page-ha-summary> -->
<!-- <app-navigation></app-navigation> -->

<router-outlet></router-outlet>